<template>
  <div class="d-flex align-center justify-center" :style="`height: ${height}`"> 
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div> 
</template> 

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'VueLoading'
});
</script>

<script setup lang="ts"> 
interface LoadingProps { height?: string; } 
const props = withDefaults(defineProps<LoadingProps>(), { height: '100vh', }); 
</script>
